import React, { useEffect, useState, useContext } from "react";
//import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import pageClasses from "./page.module.css";
import QRscanner from "../components/QRscanner";
import { parseQRtoElements } from "../tools/qroperations";
import { addBox, addBoxUsingSerialNumber } from "../api/api";
import { LookContext } from "../Contexts/LookContext";
import MyButton from "../components/MyButton";
import MySpinner from "../components/MySpinner";
import ModalAlert from "../components/modals/ModalAlert";
import ModalInfo from "../components/modals/ModalInfo";
import "./login.css";

function AddBox() {
  const [qrString, setQrString] = useState("no string");
  const [scan, setScan] = useState(false);
  const [goodQR, setGoodQR] = useState(false);
  const [box, setBox] = useState({});
  const [newAddBoxResponse, setNewAddBoxResponse] = useState(null);

  const [addBoxUsingSerialNumberResponse, setAddBoxUsingSerialNumberResponse] =
    useState(null);
  const [serialNumber, setSerialNumber] = useState("");
  const [isInvalidSerialNumber, setIsInvalidSerialNumber] = useState(false);

  const [showModalAlert, setShowModalAlert] = useState(false);
  const [modalAlertMessage, setModalAlertMessage] = useState("An Error!");
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [modalInfoMessage, setModalInfoMessage] = useState("Info Message!");
  const [isBusy, setIsBusy] = useState(false);

  const isMobile = useContext(LookContext);

  useEffect(() => {
    console.log("++++++++++++++++++++++++++++++++++++++++++++++");
    console.log(`This is Add page, and isMobile has changed to: ${isMobile}`);
    console.log("++++++++++++++++++++++++++++++++++++++++++++++");
  }, [isMobile]);

  useEffect(() => {
    if (newAddBoxResponse) {
      console.log(
        `Got a response for adding a box: ${JSON.stringify(newAddBoxResponse)}`,
      );
      if (newAddBoxResponse.success) {
        console.log("Box is added succssfully !!!!!");
        setModalInfoMessage(
          `Box is added succssfully with SN: ${newAddBoxResponse.serialNumber}, message: ${newAddBoxResponse.message}.`,
        );
        setShowModalInfo(true);
      } else {
        console.log(
          `Unable to add box with SN: ${newAddBoxResponse.serialNumber}, message: ${newAddBoxResponse.message}.`,
        );
        //show a modal alert to the user
        setModalAlertMessage(
          `Unable to add box with SN: ${newAddBoxResponse.serialNumber}, message: ${newAddBoxResponse.message}.`,
        );
        setShowModalAlert(true);
      }

      setIsBusy(false);
      setNewAddBoxResponse(null);
    }
  }, [newAddBoxResponse]);

  useEffect(() => {
    if (addBoxUsingSerialNumberResponse) {
      console.log(
        `Got a response for adding a box using serial number: ${JSON.stringify(
          addBoxUsingSerialNumberResponse,
        )}`,
      );
      if (addBoxUsingSerialNumberResponse.success) {
        console.log("Box is added succssfully !!!!!");
        setModalInfoMessage(
          `✅ Box is added succssfully with SN: ${addBoxUsingSerialNumberResponse.serialNumber}, message: ${addBoxUsingSerialNumberResponse.message}.`,
        );
        setShowModalInfo(true);
        setModalAlertMessage(null);
        setShowModalAlert(false);
      } else {
        console.log(
          `Unable to add box with SN: ${addBoxUsingSerialNumberResponse.serialNumber}, message: ${addBoxUsingSerialNumberResponse.message}.`,
        );
        //show a modal alert to the user
        setModalAlertMessage(
          `❌ Unable to add box with SN: ${addBoxUsingSerialNumberResponse.serialNumber}, message: ${addBoxUsingSerialNumberResponse.message}.`,
        );
        setShowModalAlert(true);
        setModalInfoMessage(null);
        setShowModalInfo(false);
      }

      
      setIsBusy(false);
      setAddBoxUsingSerialNumberResponse(null);
    }
  }, [addBoxUsingSerialNumberResponse]);

  useEffect(() => {
    console.log(`scan: ${scan}, goodQR: ${goodQR}.`);
  }, []);

  const displayError = (error) => {
    console.log(`Problem in reading qr string: ${error}`);
  };

  const handleReadString = (Readqrstring) => {
    console.log(`read qrstring is: ${Readqrstring}.`);
    setQrString(Readqrstring);
    const box = parseQRtoElements(Readqrstring);
    if (box) {
      setBox(box);
      setGoodQR(true);
      setScan(false);
    } else {
      setGoodQR(false);
      console.log("invalid qr string.");
    }
  };

  const handleAddUsingNumber = () => {
    
    //check if serial number is valid
    if (!serialNumber || isNaN(serialNumber) || serialNumber <= 0) {
      setIsInvalidSerialNumber(true);
      console.log("Invalid serial number, returning...");
      return;
    }

    //call the api to add box using serial number
    addBoxUsingSerialNumber(serialNumber, setAddBoxUsingSerialNumberResponse);

    //set busy to true to show spinner
    setIsBusy(true);
  };

  const handleScanButton = () => {
    setScan(true);
    setModalInfoMessage(null);
    setShowModalInfo(false);
  };

  const handleAddingBox = () => {
    console.log(`This is handleAddingBox: ${JSON.stringify(box)}.`);

    if (box) {
      try {
        addBox(box, setNewAddBoxResponse);
        setIsBusy(true);
      } catch (error) {
        console.log(`Error in adding box: ${error}.`);
      }
    }
    setGoodQR(false);
    setScan(false);
    setQrString("no string");
  };

  return (
    <div className={pageClasses.pagebody}>
      <h1 className={pageClasses.pageTitle}>إضافة صندوق جديد</h1>
      <div div className="number_container">
        <TextField
          type="number"
          id="serialNumber"
          className="input_element"
          label="Serial Number"
          autoComplete="off"
          onChange={(e) => {
            setIsInvalidSerialNumber(false);
            setSerialNumber(e.target.value);
          }}
          value={serialNumber}
          error={isInvalidSerialNumber}
          helperText={isInvalidSerialNumber ? "Invalid Serial Number" : ""}
          required
        />

        <div className="button_div">
          <MyButton
            variant={"primary"}
            onClickHandler={handleAddUsingNumber}
            title={`إضافة بالرقم`}
          />
        </div>
      </div>

      {!scan && (
        <button
          className={pageClasses.button}
          variant="contained"
          onClick={handleScanButton}
        >
          إضغط لتصوير الرمز
        </button>
      )}
      {goodQR && (
        <button
          className={pageClasses.button}
          variant="contained"
          onClick={handleAddingBox}
        >
          إضغط للإضافة بالرمز
        </button>
      )}
      <h2 className={pageClasses.qrString}>
        {" "}
        {`QR String for box: ${qrString}`}
      </h2>
      {scan && (
        <QRscanner
          className={pageClasses.scanner}
          scanHandler={handleReadString}
          errorHandler={displayError}
        />
      )}
      
      <ModalAlert
        show={showModalAlert}
        alertMessage={modalAlertMessage}
        handleClose={() => {
          setShowModalAlert(false);
        }}
      />

      <ModalInfo
        show={showModalInfo}
        infoMessage={modalInfoMessage}
        handleClose={() => {
          setShowModalInfo(false);
        }}
      />

      {isBusy && <MySpinner />}
    </div>
  );
}

export default AddBox;
